/** Employees with an Employee row only (payroll-basis and similar). */
export const EMPLOYEE_ONLY_FILTER = { name: "EMPLOYEE", value: true };

/** Active employees plus innleid (hired) users with a supplier. */
export const EMPLOYEE_OR_HIRED_FILTER = { name: "EMPLOYEE_OR_HIRED", value: true };

export const HOURS_SHEET_EMPLOYEE_FILTERS = [EMPLOYEE_OR_HIRED_FILTER];
